import { ReactElement } from 'react';

export const CornerTrimIcon = (props: Record<string, unknown>): ReactElement => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="lucide lucide-corner-trim-icon"
		{...props}
	>
		{/* dashed countertop border, inset to 6..18 to leave room for the corner brackets */}
		<path d="M6 7.5a1.5 1.5 0 0 1 1.5-1.5" />
		<path d="M10.5 6h3" />
		<path d="M16.5 6a1.5 1.5 0 0 1 1.5 1.5" />
		<path d="M18 10.5v3" />
		<path d="M18 16.5a1.5 1.5 0 0 1-1.5 1.5" />
		<path d="M10.5 18h3" />
		<path d="M7.5 18a1.5 1.5 0 0 1-1.5-1.5" />
		<path d="M6 10.5v3" />

		{/* countertop X */}
		<path d="m15 9-6 6" />
		<path d="m9 9 6 6" />

		{/* corner trims */}
		<path d="M3 6.5V3h3.5" strokeWidth="2.5" />
		<path d="M17.5 3H21v3.5" strokeWidth="2.5" />
		<path d="M21 17.5V21h-3.5" strokeWidth="2.5" />
		<path d="M6.5 21H3v-3.5" strokeWidth="2.5" />
	</svg>
);
